
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5ab156f6!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RepositorioDocs.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RepositorioDocs.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5ab156f6!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RepositorioDocs.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RepositorioDocs.vue
// module id = 85
// module chunks = 0